module.exports = __webpack_public_path__ + "img/imagem-lateral-login.ce371ec9.png";